import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import asset_e_check_hero_bg from "@/assets/e-check-hero-bg.png";
import asset_e_check_was_ist_der_e_check from "@/assets/e-check-was-ist-der-e-check.png";
import asset_e_check_haus_gewerbe from "@/assets/e-check-haus-gewerbe.png";
import asset_e_check_transparentes_ergebnis from "@/assets/e-check-transparentes-ergebnis.png";
import asset_e_check_service_der_bleibt from "@/assets/e-check-service-der-bleibt.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";

export default function ECheck() {
  return (
    <>
      <Seo
        title="E-Check & Elektroprüfung | Zweering Elektrotechnik Emmerich am Rhein"
        description="E-Check und Elektroprüfung vom Meisterbetrieb: transparente Ergebnisse und Service, der bleibt — für Haus und Gewerbe in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/e-check"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/e-check"}, {"name": "E-Check", "url": "https://zweering.de/e-check"}]}
        schema={serviceSchema("E-Check & Elektroprüfung", "Elektroprüfung nach DIN VDE für Haus und Gewerbe mit transparentem Prüfprotokoll in Emmerich am Rhein und Umgebung.", "https://zweering.de/e-check")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="E-CHECK & SERVICE"
      subline="Sicherheit, die man nicht sieht — aber spürt. Elektroprüfung und Service vom Meisterbetrieb in Emmerich am Rhein und Umgebung."
      heroImage={asset_e_check_hero_bg}
      heroImageAlt="Elektrofachkraft prüft eine Elektroinstallation in Emmerich am Rhein"
      leadText={
        <>
          Die meisten Elektroinstallationen fallen erst auf, wenn etwas nicht mehr
          funktioniert — oder gefährlich wird. Ein E-Check schafft{" "}
          <span style={{ color: "#4CAF50" }}>Gewissheit, bevor etwas passiert</span>.
        </>
      }
      panels={[
        {
          title: <>WAS IST DER<br />E-CHECK?</>,
          body: "Der E-Check ist die normgerechte Prüfung Ihrer Elektroinstallation und Ihrer Geräte. Wir kontrollieren, ob alles sicher und vorschriftsgemäß funktioniert.",
          image: asset_e_check_was_ist_der_e_check,
          imageAlt: "Geöffneter Verteilerschrank mit Sicherungsautomaten und Verkabelung",
        },
        {
          title: (
            <>
              FÜR <span style={{ color: "#4CAF50" }}>HAUS UND GEWERBE</span>
            </>
          ),
          body: "Ob Eigenheim, Vermietung oder Betrieb — wir prüfen Anlagen jeder Größe und dokumentieren das Ergebnis nachvollziehbar.",
          image: asset_e_check_haus_gewerbe,
          imageAlt: "Gewerbehalle mit Photovoltaikanlage auf dem Dach"
        },
        {
          title: "TRANSPARENTES ERGEBNIS",
          titleSize: "clamp(1.125rem, 2.6vw, 2.25rem)",
          titleClassName: "whitespace-nowrap",
          body: "Sie erhalten einen klaren Prüfbericht: was in Ordnung ist, was Aufmerksamkeit braucht und was zu tun ist — ohne Fachchinesisch.",
          image: asset_e_check_transparentes_ergebnis,
          imageAlt: "Steckdosentester zeigt das Prüfergebnis an einer Wohnungssteckdose",
        },
        {
          title: <>SERVICE,<br />DER BLEIBT</>,
          body: "Reparaturen, Wartung, Nachrüstung — als Ihr Elektro-Meisterbetrieb sind wir auch nach der Prüfung Ihr fester Ansprechpartner.",
          image: asset_e_check_service_der_bleibt,
          imageAlt: "Werkzeugtasche, Multimeter und Zangen vor einem geöffneten Verteilerschrank",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      manifest={<><span className="block">SICHERHEIT.</span><span className="block">SCHWARZ AUF WEISS.</span><span className="block">VOM MEISTERBETRIEB.</span></>}
      caseStudy={{
        title: "E-CHECK IM GEWERBEBETRIEB",
        text: "Vollständige Prüfung der Elektroinstallation mit transparenter Dokumentation, in Emmerich am Rhein und Umgebung.",
        href: "#referenzen",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/05/IMG_0177-scaled.jpeg",
        imageAlt: "Referenz: E-Check im Gewerbebetrieb in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Wann ist ein E-Check sinnvoll?",
          antwort:
            "Beim Hauskauf, vor Vermietung, in Betrieben oder einfach zur regelmäßigen Sicherheit. Wir beraten Sie, was in Ihrem Fall sinnvoll ist.",
        },
        {
          frage: "Wie lange dauert ein E-Check?",
          antwort:
            "Das hängt von der Größe der Anlage ab. Den Zeitrahmen klären wir vorab mit Ihnen.",
        },
        {
          frage: "Bekomme ich ein Prüfprotokoll?",
          antwort:
            "Ja. Sie erhalten eine nachvollziehbare Dokumentation des Prüfergebnisses.",
        },
        {
          frage: "Können Sie festgestellte Mängel direkt beheben?",
          antwort:
            "Ja. Als Elektro-Meisterbetrieb können wir notwendige Arbeiten gleich mit übernehmen — aus einer Hand.",
        },
      ]}
      ctaText={{
        headline: "SICHER, DASS ALLES SICHER IST?",
        subtext: "Vereinbaren Sie Ihren E-Check — schnell und unkompliziert.",
        buttonLabel: "Termin anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "ÜBER UNS",
        text: "Lernen Sie den Meisterbetrieb hinter Ihrer Sicherheit kennen.",
        href: "/ueber-uns",
        image: "https://www.zweering-elektrotechnik.de/wp-content/uploads/2025/11/IMG_0100.webp",
        imageAlt: "Firmengebäude Zweering Elektrotechnik",
      }}
    />
    </>
  );
}
